import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ModalFalhaAgendamento(props) {

  const handleModalOpen = () => {
    props.setState({modalFalhaOpen: true});
  };
  const handleModalClose = () => {
    props.setState({modalFalhaOpen: false});
  };

  const handleConfirm = () => {
    setTimeout(function() {
        window.location.reload();
    }, 1000);
  };

  return (
    <div>
      <Dialog
        open={props.state.modalFalhaOpen}
        onClose={handleModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Não foi possível agendar os determinados pedidos:"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.state.retornoPedidos.length > 0 &&
                <div>
                    {props.state.retornoPedidos.map((e) => {
                        return(
                            <div>
                                {"Pedido "+e.nr_pc+" para data "+e.dt_agenda}
                                <div style={{fontSize:'10pt'}}>
                                    {"Código produto: "+e.id_prod}
                                    <br/>
                                    {"Data de entrega: "+e.dt_entrg.split(' ')[0]}
                                    <br/>
                                    {"Quantidade de volume: "+e.qt_vol}
                                    <br/>
                                    {"Retorno: "+e.retorno}
                                </div>
                                <br/>
                            </div>
                        );
                    })}
                </div>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}